export const FETCH_DATA_INIT = 'FETCH_DATA_INIT'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE'
export const FETCH_USER_ATTRIBUTES = 'FETCH_USER_ATTRIBUTES'
export const RESET_USER_DATA = 'RESET_USER_DATA'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'

export const benefits = [
    {
      emoji: '🚚',
      title: 'Free Shipping',
      text: 'Free shipping on all orders over $50!'
    },
    {
      emoji: '🔒',
      title: 'Secure Payment',
      text: 'Shop with safety and security'
    },
    {
      emoji: '💯',
      title: '100% Satisfaction',
      text: '30-day money back guarantee'
    },
    {
      emoji: '💬',
      title: 'Customer Service',
      text: 'Reliable, friendly support'
    }
  ]
